import { useNavigate } from 'react-router'

import ExclamationCircleOutlined from '@ant-design/icons/ExclamationCircleOutlined'

import Chip from '@mui/material/Chip'
import Fade from '@mui/material/Fade'

import useIndicator, { Indicator } from '@shared/hooks/src/useIndicator'

export default function OnDemandPending() {
  const navigate = useNavigate()

  const { data: hasAppointmentsPending } = useIndicator(
    Indicator.HasOnDemandOrAsyncMessaging,
    { scope: 'provider_queue' },
    { select: (data) => data.show_icon }
  )

  return (
    <Fade in={hasAppointmentsPending} unmountOnExit>
      <Chip
        color="primary"
        variant="outlined"
        icon={<ExclamationCircleOutlined />}
        label="Appointments pending"
        clickable
        onClick={() => navigate('/app/appointments')}
        sx={{ ml: 1 }}
      />
    </Fade>
  )
}
